/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import {
  AtcDTO,
  ChecklistDTO,
  CreditRequestDTO,
  CreditUseListDTO,
  FormDTO,
  NotificationDTO,
  PositionDTO,
  SurveyDTO,
  UserDataDTO,
  WizardStepNextOutputDTO
} from '@api/models';
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { Injectable } from '@angular/core';
import { beToFeDate } from '@core/utils';

@Injectable()
export class ApiResParserCustomService extends ApiResParserService {
  constructor() {
    super();
  }

  generic<T>(res: any): T {
    return res;
  }

  userData(res: any): UserDataDTO {
    return res;
  }

  position(res: any): PositionDTO {
    res = this.cleanPayload(res);

    res.tuple = [res.product];

    return res;
  }

  savePosition(res: any): string {
    return this.cleanPayload(res);
  }

  forms(res: any): FormDTO[] {
    return res;
  }

  surveys(res: any): SurveyDTO[] {
    return (res && res.surveys) || [];
  }

  checklist(res: any): ChecklistDTO {
    return this.cleanPayload(res);
  }

  atc(res: any): AtcDTO[] {
    return this.cleanPayload(res);
  }

  notifications(res: any): NotificationDTO[] {
    return this.cleanPayload(res);
  }

  workflowTaskClose(res: any): WizardStepNextOutputDTO {
    return {
      outcome: res.payload || null,
      messages: (
        (res.metadata && (res.metadata.messages as { code: string }[])) ||
        []
      )
        .map(x => x.code || null)
        .filter(x => !!x)
    };
  }

  quotationCreditRequest(res: any): CreditRequestDTO {
    const output = this.cleanPayload<CreditRequestDTO>(res);

    return output
      ? { ...output, expireDate: beToFeDate(output.expireDate) }
      : {};
  }

  quotationCreditUse(res: any): CreditUseListDTO {
    const output = this.cleanPayload<CreditUseListDTO>(res);

    if (output && output.uses instanceof Array) {
      output.uses.forEach(use => (use.expireDate = beToFeDate(use.expireDate)));
    }

    return output;
  }
}
